<div class="flex flex-wrap lg:flex-nowrap gap-5">
  <div class="w-full lg:w-1/2">
    <p-tabs value="1">
      <p-tablist>
        <p-tab value="1">Sobre o cliente</p-tab>
        <p-tab value="2">Documentos</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="1">
          <div class="text-xl font-bold mb-6">Sobre o Cliente</div>

          <div class="text-lg font-bold mb-3">Dados pessoais</div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div class="text-sm font-bold">Nome Completo</div>
              <div class="mt-1">
                {{ customer.fullName || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">Data de Nascimento</div>
              <div class="mt-1">
                {{ customer.dateOfBirth | date: "dd/MM/yyyy" }}
              </div>
            </div>
          </div>

          <hr class="my-6" />

          <div class="text-lg font-bold mb-3">Contato</div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div class="text-sm font-bold">Telefone</div>
              <div class="mt-1">{{ primaryPhone }}</div>
            </div>

            <div>
              <div class="text-sm font-bold">E-mail</div>
              <div class="mt-1">{{ primaryEmail }}</div>
            </div>
          </div>

          <hr class="my-6" />

          <div class="text-lg font-bold mb-3">Endereço de entrega</div>

          <div class="flex flex-wrap gap-6">
            <div class="md:col-span-2">
              <div class="text-sm font-bold">Street Address</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.street || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">Apt, Suite, Unit (Optional)</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.complement || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">City</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.city || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">State</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.state || "-" }}
              </div>
            </div>

            <div>
              <div class="text-sm font-bold">ZIP Code</div>
              <div class="mt-1">
                {{ order()?.shippingAddress?.zipCode || "-" }}
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="2">
          <div class="text-xl font-bold mb-6">Documentos</div>

          @if (documents.length) {
            <div class="space-y-6">
              @for (doc of documents; track $index) {
                <div class="flex items-center justify-between gap-4">
                  <div class="flex items-center gap-4">
                    <i
                      class="ph ph-file-text text-purple-primary-500 text-4xl"
                    ></i>

                    <div>
                      <div class="font-bold">
                        {{ getDocumentNameByType(doc.type) }}
                      </div>
                      <div class="text-sm">
                        Enviado em
                        {{ doc.uploadedAt | date: "dd/MM/yyy HH:mm" }}
                      </div>
                    </div>
                  </div>

                  <div class="flex gap-2">
                    <a
                      pButton
                      rounded
                      severity="secondary"
                      class="btn-secondary-outline"
                      [href]="doc.fileUrl"
                      target="_blank"
                    >
                      Baixar
                    </a>
                  </div>
                </div>

                @if ($index < documents.length - 1) {
                  <hr />
                }
              }
            </div>
          } @else {
            <div class="">Nenhum documento enviado.</div>
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  @if (underReview()) {
    <div class="w-full lg:w-1/2">
      <app-order-assessment
        [orderId]="order()?.id"
        [orderStatus]="order()?.status"
        [eligibilityAssessment]="eligibilityAssessment()"
        [customerName]="customer.fullName"
        [approvalPrerequisites]="order()?.approvalPrerequisites ?? null"
        (reloadOrder)="reloadOrder()"
      />
    </div>
  }
</div>
